<template>
    <div class="page">
        <div class="top">
            <div class="top-back" @click="toBuyPkg">
                <van-icon name="arrow-left" />
            </div>
            <div class="top-name">投诉历史</div>
        </div>
        <div class="uni-list-item" v-for="(item,index) in dataList" :key="index" @click="detailsLink(item)">
            <div class="left">
                {{ item.currentTime }}
            </div>
            <div class="right"><span>{{ item.disposeStateName }}</span><van-icon name="arrow" /></div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { wxRequest } from '@/api/user'
export default{
    data(){
        return{
            dataList:[],
            iccid: localStorage.getItem("iccid"),
            myIccid: localStorage.getItem("myIccid")
        }
    },
    created(){
        this.init()
    },
    methods:{
        toBuyPkg(index){
            this.$router.push({
                path: "/user/entrance"
            });
        },
        detailsLink(data){
            this.$router.push({
                path: "/user/complaintResult",
                query:{id:data.id}
            });
        },
        init(){
            wxRequest("/userProblem/userInfo", {iccid:this.myIccid ? this.myIccid:this.iccid}, "post").then(res => {
                if(res.data.code === '200'){
                    this.dataList = res.data.data.resultList
                }else{
                    Toast.fail(res.data.message); 
                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
div{
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}
.page{
	height:100%;
	background: #f7f8fa;
    .top{
        flex-direction: row;
        align-items: center;
        height: 44px;
        background-color: #3bb272;
        .top-back{
            width:30px;
            align-items: center;
            text-align: center;
            position: absolute;
            height: 44px;
            line-height: 44px;
            justify-content: center;
            color: #fff;
            font-size:20px;
        }
        .top-name{
            text-align: center;
            font-size: 17px;
            color: #fff;
            flex: 1 1 0%;
        }
    }
    .uni-list-item{
        font-size: 14px;
        position: relative;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        flex-direction: row;
        cursor: pointer;
    }
    .left{
        position: relative;
        flex-direction: row;
        padding: 12px 15px;
        padding-left: 15px;
        flex: 1;
        color: #3b4144;
        overflow: hidden;
    }
    .right{
        color: #bbbbbb;
        flex-direction: row;
        font-size: 16px;
        padding: 0 10px;
        align-items: center;
        span{
            color: #999;
            font-size: 12px;
        }
    }
}
</style>
